import { Box, ToggleButton, IconButton, Badge } from '@mui/material';

import ViewListIcon from 'modules/common/components/Icons/ViewListIcon';
import PaperClipIcon from 'modules/common/components/Icons/PaperClipIcon';
import EmojiHappyIcon from 'modules/common/components/Icons/EmojiHappyIcon';
import SendIcon from 'modules/common/components/Icons/SendIcon';

interface ControlsProps {
    showControls: boolean;
    toggleControls: () => void;
    showEmojiPicker: boolean;
    toggleEmojiPicker: () => void;
    showFileUploader: boolean;
    toggleFileUploader: () => void;
    filesCount: number;
    onSendMessage: () => void;
    canSend: boolean;
    disableButtons?: boolean;
}

export default function Controls({
    showControls,
    toggleControls,
    showEmojiPicker,
    toggleEmojiPicker,
    showFileUploader,
    toggleFileUploader,
    filesCount,
    onSendMessage,
    canSend,
    disableButtons = false,
}: ControlsProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }} gap={0.5}>
            <ToggleButton
                value="format"
                selected={showControls}
                disabled={disableButtons}
                onChange={toggleControls}
                // Remove when the variant small is fixed
                sx={{ p: 1 }}>
                <ViewListIcon sx={{ width: 20, height: 20 }} />
            </ToggleButton>
            <Badge badgeContent={filesCount} color="primary">
                <ToggleButton
                    value="attachment"
                    selected={showFileUploader}
                    disabled={disableButtons}
                    onClick={toggleFileUploader}
                    // Remove when the variant small is fixed
                    sx={{ p: 1 }}>
                    <PaperClipIcon sx={{ width: 20, height: 20 }} />
                </ToggleButton>
            </Badge>
            <ToggleButton
                value="emoji"
                selected={showEmojiPicker}
                disabled={disableButtons}
                onChange={toggleEmojiPicker}
                // Remove when the variant small is fixed
                sx={{ p: 1 }}>
                <EmojiHappyIcon sx={{ width: 20, height: 20 }} />
            </ToggleButton>
            <IconButton color="primary" onClick={onSendMessage} disabled={!canSend} sx={{ ml: 'auto' }}>
                <SendIcon sx={{ width: 20, height: 20 }} />
            </IconButton>
        </Box>
    );
}
